import React from "react";
import { NavLink } from "react-router-dom";

const Service = () => {
  return (
    <section className="bg-[#123638] py-16 text-white sm:py-24">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="flex flex-col md:flex-row items-center">
          <div className="w-full md:w-1/2 text-center md:text-left">
            <p className="text-xs font-bold uppercase tracking-[.2em] text-teal-200">Who we are</p><h2 className="mt-3 text-3xl font-bold sm:text-4xl">Our company</h2>
            <p>
              With our services, we diligently aim to add to the value
              proposition of your brand.
            </p>
          </div>
          <div className="w-full md:w-1/2 mt-8 md:mt-0">
            <p className="leading-8 text-slate-200">
              We begin by listening to you, understanding your industry, and
              analyzing your needs. From there, we craft a personalized strategy
              that aligns with your brand's values and goals. Our tailored
              solutions are not one-size-fits-all but created specifically to
              resonate with your target audience. We leverage cutting-edge
              technology and an agile development process to deliver results
              that not only meet but exceed your expectations.
            </p>
          </div>
        </div>
        <div className="mt-14 grid grid-cols-1 gap-px overflow-hidden rounded-lg bg-white/15 sm:grid-cols-2 lg:grid-cols-4">
          <div className="flex flex-col bg-[#173f41] p-6">
            <h3 className="text-2xl font-bold mb-2">Mission & Values</h3>
            <p className="text-white-400">
              Our mission is to help our clients achieve their business goals by
              providing them with the highest quality digital marketing
              services.
            </p>
            <NavLink to='/mission-values' className="btn btn-secondary mt-auto">Read More</NavLink>
          </div>
          <div className="flex flex-col bg-[#173f41] p-6">
            <h3 className="text-2xl font-bold mb-2">Why Choose Us</h3>
            <p className="text-white-400">
              We have a team of experienced professionals who are passionate
              about what they do.
            </p>
            <NavLink to='/choose-us' className="btn btn-secondary mt-auto">Read More</NavLink>
          </div>
          <div className="flex flex-col bg-[#173f41] p-6">
            <h3 className="text-2xl font-bold mb-2">Our Commitment</h3>
            <p className="text-white-400">
              We are committed to providing our clients with the best possible
              service.
            </p>
            <NavLink to='/contact' className="btn btn-secondary mt-auto">Contact us</NavLink>
          </div>
          <div className="flex flex-col bg-[#173f41] p-6">
            <h3 className="text-2xl font-bold mb-2">Our Expertise</h3>
            <p className="text-white-400">
              We have a wide range of expertise in all areas of digital
              marketing.
            </p>
            <NavLink to='/web-development' className="btn btn-secondary mt-auto">Our services</NavLink>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Service;
